import graduacionReducer from './graduacionReducer';

export default graduacionReducer;